/* ==========================================================================
   Three Tails — Revamp overlays: entry offer popup, sticky bar, floating CTA.
   ========================================================================== */
(function () {
  'use strict';

  var SEEN_KEY = 'tt_offer_popup_seen';
  /* CORRECCIÓN 2026-08-04 (ronda de pulido, orden del fundador): "el popup
     tapa el hero entero — es lo primero que ve cualquiera". Con 6s de
     espera y exit-intent armado desde el segundo 0, el popup casi siempre
     se abría ANTES de que el usuario alcanzara a scrollear, es decir,
     encima del hero. Regla dura ahora: nunca se abre mientras el hero está
     en pantalla, sin excepción — ni el temporizador ni el exit-intent
     pueden saltarse esa condición (ver heroCleared() abajo). Se abre en
     cuanto el usuario deja atrás el hero (scroll) o, como respaldo, a los
     POPUP_DELAY_MS si para entonces ya lo dejó atrás. */
  var POPUP_DELAY = 14000; // ms de respaldo — sólo abre si ya se dejó el hero atrás

  function initPopup() {
    var pop = document.getElementById('tt-pop');
    if (!pop) return;
    var card = pop.querySelector('.tt-pop__card');
    var closeBtn = document.getElementById('tt-pop-close');
    var form = document.getElementById('tt-pop-form');
    var gate = pop.querySelector('.tt-pop__gate');
    var reveal = document.getElementById('tt-pop-reveal');
    var opened = false;

    function open() {
      if (opened) return;
      opened = true;
      pop.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { pop.classList.add('tt-pop--open'); });
    }
    function close() {
      pop.classList.remove('tt-pop--open');
      setTimeout(function () { pop.hidden = true; }, 300);
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    }

    // Don't auto-show if already seen
    var seen = false;
    try { seen = localStorage.getItem(SEEN_KEY) === '1'; } catch (e) {}

    // Returning from Shopify's /challenge captcha (native-submit fallback):
    // if the capture went through, deliver the promised code.
    var challenged = false;
    try { challenged = localStorage.getItem('tt-pop-challenge') === '1'; } catch (e) {}
    if (challenged) {
      try { localStorage.removeItem('tt-pop-challenge'); } catch (e) {}
      if (window.location.search.indexOf('contact_posted=true') !== -1) {
        if (typeof window.fbq === 'function') {
          try { window.fbq('track', 'Lead', { content_name: 'Intro Offer Popup' }); } catch (e) {}
        }
        try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
        seen = true;
        if (gate) gate.style.display = 'none';
        if (reveal) reveal.style.display = 'block';
        open();
      }
    }

    // Nunca abrir tapando el hero: sólo cuenta como "dejado atrás" una vez
    // que se scrolleó más de la mitad de su alto (o si no hay hero en esta
    // plantilla, por ejemplo el PDP — ahí no aplica el bloqueo).
    var heroEl = document.getElementById('tt-hero');
    function heroCleared() {
      if (!heroEl) return true;
      return window.scrollY > (heroEl.offsetHeight * 0.5);
    }

    if (!seen) {
      var timer = setTimeout(function () { if (heroCleared()) open(); }, POPUP_DELAY);
      // Se abre en el momento en que el usuario deja atrás el hero, sin
      // esperar el respaldo de arriba — "que aparezca al desplazar".
      document.addEventListener('scroll', function onScroll() {
        if (!opened && heroCleared()) {
          open();
          clearTimeout(timer);
          document.removeEventListener('scroll', onScroll);
        }
      }, { passive: true });
      // exit-intent (desktop) — mismo candado: nunca antes de dejar el hero.
      document.addEventListener('mouseout', function onLeave(e) {
        if (e.clientY <= 0 && !opened && heroCleared()) {
          clearTimeout(timer);
          open();
          document.removeEventListener('mouseout', onLeave);
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('tt-pop--open')) close(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('button[type="submit"]');
        var errorEl = document.getElementById('tt-pop-error');
        if (submitBtn && submitBtn.disabled) return; // already in flight

        function onSuccess() {
          if (typeof window.fbq === 'function') {
            try { window.fbq('track', 'Lead', { content_name: 'Intro Offer Popup' }); } catch (err) {}
          }
          try { localStorage.setItem(SEEN_KEY, '1'); } catch (err) {}
          if (gate) gate.style.display = 'none';
          if (reveal) reveal.style.display = 'block';
        }
        function onFailure() {
          if (submitBtn) submitBtn.disabled = false;
          if (errorEl) errorEl.hidden = false;
        }

        if (submitBtn) submitBtn.disabled = true;
        if (errorEl) errorEl.hidden = true;

        // Submit to Shopify and only reveal the code once the capture succeeds.
        // Shopify may 302-redirect the /contact POST; fetch follows it. A 2xx
        // landing on /challenge is Shopify's spam captcha — NOT a capture — so
        // fall back to a native form submission there (bypasses this handler).
        try {
          fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
            .then(function (res) {
              if (res && res.ok && String(res.url).indexOf('/challenge') === -1) { onSuccess(); }
              else if (res && res.ok) { try { localStorage.setItem('tt-pop-challenge', '1'); } catch (e2) {} form.submit(); }
              else { onFailure(); }
            })
            .catch(function () { onFailure(); });
        } catch (err) {
          onFailure();
        }
      });
    }

    // expose for manual trigger (e.g. a future "get offer" link)
    window.ttOpenOfferPopup = open;
  }

  function initStickyAndFab() {
    var bar = document.getElementById('tt-stickybar');
    var fab = document.getElementById('tt-fab');
    if (!bar && !fab) return;

    var lastY = 0;
    function onScroll() {
      var y = window.pageYOffset;
      var show = y > 700; // past the fold
      if (bar) bar.classList.toggle('tt-stickybar--show', show);
      // FAB hides while the sticky bar is up to avoid overlap on mobile
      if (fab) fab.classList.toggle('tt-fab--show', show && window.innerWidth >= 768);
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    initPopup();
    initStickyAndFab();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
